import { render } from "./WildBookEntryLocation.vue?vue&type=template&id=310e2c23&scoped=true&ts=true"
import script from "./WildBookEntryLocation.vue?vue&type=script&lang=ts"
export * from "./WildBookEntryLocation.vue?vue&type=script&lang=ts"

import "./WildBookEntryLocation.vue?vue&type=style&index=0&id=310e2c23&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310e2c23"]])

export default __exports__